// Pure formatters for the hosting Manage panel (components/HostingManagePanel.jsx).

export function formatBytes(n) {
  const v = Number(n);
  if (n === null || n === undefined || n === '' || !Number.isFinite(v) || v < 0) return '—';
  if (v < 1024) return `${v} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let x = v / 1024;
  let i = 0;
  while (x >= 1024 && i < units.length - 1) { x /= 1024; i += 1; }
  return `${x < 10 ? x.toFixed(1) : Math.round(x)} ${units[i]}`;
}

// Restore points arrive as ISO strings, epoch ms or Firestore-ish
// { _seconds }. A missing date is shown as unknown, never as 1970.
export function formatPointDate(value) {
  if (value === null || value === undefined || value === '') return 'Unknown date';
  let d;
  if (typeof value === 'object' && value !== null && Number.isFinite(value._seconds)) d = new Date(value._seconds * 1000);
  else d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}
